import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import ServiceListings from "./sections/ServiceListings";
import OurApproach from "./sections/OurApproach";
import GetStartedCta from "./sections/GetStartedCta";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <ServiceListings />
      <OurApproach />
      <GetStartedCta />
      <Footer />
    </div>;
}